<template>
<div class="show-list">
  <ul>
    <li v-for="item in data">
      <dl>
        <dt>创建时间：</dt>
        <dd>{{item.createTime | formDate}}</dd>
      </dl>
      <dl>
        <dt>姓名：</dt>
        <dd>{{item.name}}</dd>
      </dl>
      <dl>
        <dt>电话：</dt>
        <dd>{{item.phone || '--'}}</dd>
      </dl>
      <dl>
        <dt>公司：</dt>
        <dd>{{item.company || '--'}}</dd>
      </dl>
      <dl>
        <dt>邮箱：</dt>
        <dd>{{item.email || '--'}}</dd>
      </dl>
      <dl>
        <dt>疑问：</dt>
        <dd>{{item.memo || '--'}}</dd>
      </dl>
    </li>
  </ul>
  <web-page v-bind:total="num" @pageto="goPage" v-if="num > 1"></web-page>
</div>
</template>
<script>
import pages from '@/components/pages/page'
import {
  formUTCDate
} from '../../date'
export default {
  name: "show",
  data: () => ({
    data: [],
    pages: 1,
    num: 1
  }),
  components: {
    'web-page': pages
  },
  filters: {
    formDate(time) {
      return formUTCDate(time)
    }
  },
  methods: {
    getDate() {
      const _this = this;
      this.$axios({
          method: 'get',
          url: 'applications',
          params: {
            page: _this.pages,
            page_size: 15
          }
        })
        .then((res) => {
          console.log(res);
          _this.data = res.data.applications
          _this.num = res.data.totalPage
        })
    },
    goPage: function(nums) {
      // console.log(nums)
      this.pages = nums
      this.getDate()
    }
  },
  mounted() {
    this.getDate()
  }
}
</script>
<style lang="scss" scoped>
.show-list {

    li {
        background-color: #fff;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0 0 4px rgba(0,0,0,0.5);
        margin: 12px 10px 0;
    }

    dl {
        display: flex;
        line-height: 28px;
        color: #666;
        border-bottom: 1px solid #eee;

        &:last-child {
            border-bottom: 0;
        }

        dt {
            flex: 1;
            font-size: 14px;
        }
        dd {
            flex: 4;
            font-size: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/show/list.vue